import {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

const activityContext = createContext<any>({
  cycle_count: 1,
});

const { Provider } = activityContext;

const useActivityProvider = () => {
  const [activityCtx, setActivityCtx] = useState(null);

  const values = useMemo(() => {
    return {
      activityCtx,
      setActivityCtx,
    };
  }, [activityCtx, setActivityCtx]);

  return values;
};

export const ActivityProvider = ({
  children,
}: {
  children: ReactElement | ReactNode;
}) => {
  const auth = useActivityProvider();
  return <Provider value={auth}>{children}</Provider>;
};

export const useActivity = () => useContext(activityContext);
